'use strict';

(function() {
	angular.module('onboarding.common')
		.filter('sin',
			function() {
				return function(sin) {
					if (!sin) {
						return '';
					}

					var value = sin.toString().trim().replace(/^\+/, '');

					if (value.match(/[^0-9]/)) {
						return sin;
					}

					var first, second, third, number;

					switch (value.length) {
					case 1:
					case 2:
					case 3:
						first = value;
						break;
					case 4:
					case 5:
					case 6:
						first = value.slice(0, 3);
						second = value.slice(3);
						break;
					default:
						first = value.slice(0, 3);
						second = value.slice(3, 6);
						third = value.slice(6);
						break;
					}

					if (third) {
						number = first + '-' + second + '-' + third;
					} else {
						if (second) {
							number = first + '-' + second;
						} else {
							number = first;
						}
					}

					return number;
				};
			});
})();
